import { Link } from 'react-router-dom';
import { HUB_LINKS } from '../data/siteMeta';
import { APP_VERSION, BUILD_DATE } from '../generated/build-info';
import './SiteFooter.css';

const POPULAR = [
  ['/json-parser', 'JSON Parser'],
  ['/jwt-decoder', 'JWT Decoder'],
  ['/hash-generator', 'Hash Generator'],
  ['/qr-code-generator', 'QR Code Generator'],
  ['/password-generator', 'Password Generator'],
];

// Rendered once in App.tsx below every route: categories, popular tools and the site links, so Home,
// About, Contact, Privacy and Terms are reachable from anywhere (also needed for AdSense review).
const SiteFooter = () => (
  <footer className="site-footer dsk-root">
    <div className="site-footer-columns">
      <nav aria-label="Tool groups">
        <p className="site-footer-heading">Tool groups</p>
        <ul>
          {HUB_LINKS.map((hub) => (
            <li key={hub.path}>
              <Link to={hub.path}>{hub.label}</Link>
            </li>
          ))}
        </ul>
      </nav>
      <nav aria-label="Popular tools">
        <p className="site-footer-heading">Popular tools</p>
        <ul>
          {POPULAR.map(([path, title]) => (
            <li key={path}>
              <Link to={path}>{title}</Link>
            </li>
          ))}
        </ul>
      </nav>
      <nav className="site-footer-links" aria-label="DevStackKit">
        <p className="site-footer-heading">DevStackKit</p>
        <ul>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/tools">All tools</Link></li>
          <li><Link to="/saved">My Saved</Link></li>
          <li><Link to="/about">About</Link></li>
          <li><Link to="/contact">Contact</Link></li>
          <li><Link to="/privacy-policy">Privacy Policy</Link></li>
          <li><Link to="/terms">Terms</Link></li>
        </ul>
      </nav>
    </div>
    <p className="site-footer-copyright">© {new Date().getFullYear()} DevStackKit. Most tools run in your browser, so your data stays on your device (the REST API tester sends requests to the address you enter).</p>
    <p className="site-footer-version">DevStackKit v{APP_VERSION} · Updated {BUILD_DATE}</p>
  </footer>
);

export default SiteFooter;
